module.exports = __webpack_public_path__ + "img/a7f2e77.jpg";